<template>
  <form-modal
    :id="id"
    :ref="id"
    :placeholder-button="tituloBotao"
    :fields="colunasMutaveis"
    :values="dadosMutaveis"
    @ok="$emit('ok', $event)"
    @cancel="$emit('cancel', $event)"
    @edit="$emit('edit', $event)"
    @remove="$emit('remove', $event)"
    :titleModal="tituloModal"
    :create="criar"
    :read="ler"
    :update="atualizar"
    :remove="remover"
    :controles="controles"
    hide-button
    :somente-ok="somenteOk"
    :ok-cancel="okViraCancelar"
    :accordion-title="tituloTabelaMutavel"
  >
    <template #title
      ><slot name="titulo-modal">{{ tituloModal }}</slot></template
    >
    <template #after-button>
      <b-button
        variant="success"
        @click="baixarComprovantes"
        class="ml-2"
        size="sm"
      >
        <i class="fas fa-cloud-download mr-2"></i>
        Baixar comprovantes
      </b-button>
    </template>
    <template #beforeTable>
      <accordion
        :id="`${id}-1`"
        :title="tituloTabelaImutavel"
        sub
        :accordion="id"
        visible
      >
        <div class="p-3">
          <b-table
            head-variant="dark"
            hover
            :items="dadosImutaveis"
            :fields="colunasImutaveis"
          >
            <template v-slot:[`cell(${colunaImagem})`]="data">
              <b-avatar :src="data.value"></b-avatar>
            </template>
          </b-table>
        </div>
      </accordion>
    </template>
    <template #modal>
      <slot name="modal"></slot>
    </template>
  </form-modal>
</template>
<script>
import FormModal from "@/components/modal/FormModal";
import Accordion from "@/components/card/Accordion";
export default {
  name: "FormModalPersonalizado",
  components: {
    FormModal,
    Accordion,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    tituloBotao: {
      type: String,
      default: "Inserir",
    },
    tituloModal: {
      type: String,
      default: "",
    },
    tituloTabelaMutavel: {
      type: String,
      default: "",
    },
    colunasMutaveis: {
      type: Array,
      default: () => [],
    },
    dadosMutaveis: {
      type: Array,
      default: () => [],
    },
    colunaImagem: {
      type: String,
      default: null,
    },

    controles: {
      type: Boolean,
      default: false,
    },
    tituloTabelaImutavel: {
      type: String,
      default: "",
    },
    colunasImutaveis: {
      type: Array,
      default: () => [],
    },
    dadosImutaveis: {
      type: Array,
      default: () => [],
    },
    criar: {
      type: Boolean,
      default: false,
    },
    ler: {
      type: Boolean,
      default: false,
    },
    atualizar: {
      type: Boolean,
      default: false,
    },
    remover: {
      type: Boolean,
      default: false,
    },
    somenteOk: {
      type: Boolean,
      default: false,
    },
    okViraCancelar: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    openModal: function () {
      this.$refs[this.id].openModal();
    },

    closeModal: function () {
      this.$refs[this.id].closeModal();
    },
    baixarComprovantes: function (e) {
      e.stopPropagation();
      this.$emit("baixarComprovantes");
    },
  },
};
</script>
<style lang="">
</style>